import { InputOptions } from './types';
import { isValidDayInput, isValidMonthInput, isValidYearInput } from './utils';

export const ALL_INPUTS: InputOptions[] = [
  {
    key: 'month',
    label: 'Month',
    maskOptions: {
      mask: '0[0]',
      validate: isValidMonthInput,
    },
    placeholder: 'mm',
  },
  {
    key: 'day',
    label: 'Day',
    maskOptions: {
      mask: '0[0]',
      validate: isValidDayInput,
    },
    placeholder: 'dd',
  },
  {
    key: 'year',
    label: 'Year',
    maskOptions: {
      mask: '0000',
      validate: isValidYearInput,
    },
    placeholder: 'yyyy',
  },
];
